export const SET_TRANSLATIONS = 'translations/SET_TRANSLATIONS';

export const setTranslations = (payload) => ({
  type: SET_TRANSLATIONS,
  translations: payload,
});
